import type { Sport } from '@h2h/shared';
import type { Tab } from '../../round-play/types';

/** Shared hub copy — same structure for football and cycling, sport-specific words only where needed. */
export function hubLabels(sport: Sport) {
  const cycling = sport === 'CYCLING';
  return {
    scheduleTab: cycling ? 'Stages' : 'Fixtures',
    scheduleTabKey: (cycling ? 'stages' : 'fixtures') as Tab,
    tableTab: 'Table',
    competeBackBody: cycling
      ? 'Call your six duels and check your division rank'
      : 'Build your cards and check your division rank',
    competeHint: cycling
      ? 'Rank all six rider duels — confidence ladder sets the stakes.'
      : 'Build cards on any fixtures · 1X2 base plus optional boosts on each card.',
    playedLabel: 'Played',
    playLink: cycling ? 'Call duels' : 'Build cards',
    scheduleLink: cycling ? 'Stages' : 'Fixtures',
    emptySlateTitle: cycling ? 'No open stage right now' : 'No open round right now',
    emptySlateBody: cycling
      ? 'The next stage appears here as soon as it’s scheduled.'
      : 'The next round appears here as soon as it’s scheduled.',
    scheduleHint: cycling
      ? 'Every stage in the race — your duel calls, live grades, and stage recap.'
      : 'Every match this round — your cards, live grades, and round recap.',
    tableHint: cycling
      ? 'Race standings from the competition — separate from your HeadToHead division.'
      : 'Real league standings from the competition — separate from your HeadToHead division.'
  };
}
